import { FormFieldConfig, tokens } from '@sail/ui';
import { assignTokens } from '@sail/engine';
export const formFieldCustomization = FormFieldConfig.customize({
    uses: [
        assignTokens(tokens.font.label.small.lineHeight, '1.5')
    ]
});

//# sourceMappingURL=formField.js.map